import React, {useState} from "react";
import MangeDashboard from "./MangeDashboard";
import axios from "axios";
import {useNavigate} from "react-router-dom";
import Toast from "./Tost";
import './CartEhraz.css'
import { ToastContainer, toast } from 'react-toastify';
import Resizer from "react-image-file-resizer";

axios.defaults.withCredentials = true;

export function CartEhraz() {
        const [error,seterror] =useState()
  
        const [flag,setflag] = useState(false) 
        const [message,setmessage] = useState('')
        const [type,settype] = useState('')
        const navigate = useNavigate();
        const[isLoading,setIsLoading] = useState(false)
        const [cardNumber, setcardNumber] = useState('');
        const [shebaNumber, setshebaNumber] = useState('');
        const [errorBank, seterrorBank] = useState('');
        const [errorSheba,setErrorSheba] = useState('')
        const resizeFile = (file) => new Promise(resolve => {
            Resizer.imageFileResizer(file, 1200, 1200, 'JPEG', 100, 0,
            uri => {
              resolve(uri);
            }, 'file' );
            });
        



        var IsDigit = new RegExp(/^[0-9]/);
        var IsSheba = new RegExp(/^IR[0-9]/)






        

      function validateCard(card) {
        if (typeof card === 'undefined'
          || card === null
          || card.length !== 16) {
          return false;
        }
        let cardTotal = 0;
        for (let i = 0; i < 16; i += 1) {
          const c = Number(card[i]);
          if (i % 2 === 0) {
            cardTotal += ((c * 2 > 9) ? (c * 2) - 9 : (c * 2));
          } else {
            cardTotal += c;
          }
        }
        return (cardTotal % 10 === 0);
      }



      function validateSheba(card) {
        if (typeof card === 'undefined'
          || card === null
          || card.length !== 24) {
          return false;
        }else{
            return true;
        }
       
      }



      const removeSpaces = (value) => {
        return value.replace(/\s+/g, '');
    };



    const formatCardNumber = (value) => {
        return value.replace(/\s?/g, '').replace(/(\d{4})/g, '$1 ').trim();
    };




        const handleChange = (event) => {

            var name = event.target.name
            var value = event.target.value

            if (name == 'card_number'){
                setcardNumber(formatCardNumber(value))
    
                if (validateCard(removeSpaces(value))){
                    seterrorBank('')
                }else{
                    seterrorBank('شماره کارت خود را به درستی وارد نمایید')
                }
                
            }
            else if (name == 'sheba'){
                setshebaNumber(value)
    
                if (validateSheba(value)){
                    setErrorSheba('')
                }else{
                    setErrorSheba('شماره شبا خود را به درستی وارد نمایید')
                }
                
            }

        }



        function toEnglishNumber(strNum) {
            var pn = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
            var en = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
            var an = ["٠", "١", "٢", "٣", "٤", "٥", "٦", "٧", "٨", "٩"];
            var cache = strNum;
            for (var i = 0; i < 10; i++) {
                var regex_fa = new RegExp(pn[i], 'g');
                var regex_ar = new RegExp(an[i], 'g');
                cache = cache.replace(regex_fa, en[i]);
                cache = cache.replace(regex_ar, en[i]);
            }
            return cache;
        }


       function handelSubmit(event){



        setflag(true)
        
        event.preventDefault()
        const  formdata = new FormData();
        if(!cardNumber || !shebaNumber)
        {
            toast.error('لطفا اطلاعات کارت را کامل وارد نمایید')
            return
        }






        




        let cardNumberEng = toEnglishNumber(removeSpaces(cardNumber))
        let shebaNumberEng = toEnglishNumber(shebaNumber)





        setIsLoading(true)
        

        formdata.append('cartNumbrr',cardNumberEng)
        formdata.append('shebaNumber',`IR${shebaNumberEng}`)
        formdata.append('cart','')






        axios.post('https://api.sinatether.com/Auth/CartEhraz/',formdata,{
           withCredentials:true,},).then((response) =>{
            console.log(response)
            if (response.status == 200){
                if (response.data['status'] == 200)
                {

                    navigate('/Ehrazwaiting')
                    
                }else if (response.data['status'] == 201)
                {
                   toast.error('کارت بانکی شما قبلا احراز شده است ')

                }
                else if (response.data['status'] == 202)
                {
                    toast.error('کارت بانکی شما در انتظار تایید احراز  است ')


                }
                setIsLoading(false)



            }

                
               
                

        }

        ).catch(error =>{
            if (error)
            {
                console.log(error.response.status)
                if (error.response.status === 400){
                    toast.dismiss()
                    toast.error("نشست شما منقضی شده است مجددا وارد شوید")
                }else{
                toast.dismiss()
                toast.error('اطلاعات به درستی ارسال نشد دوباره امتحان کنید')
                setIsLoading(false)
                }


            }

            }
        )


        
  }






    return(
        <MangeDashboard>
            <Toast type={type} message={message}/>


            <div className="verification21  align-items-center  mt-5 pt-5">
                <div className="container align-items-center setStyleSlider ">
                <div className="identity-content pcss34242 text-center">
                                            <img className="sjfhsjgfnkrwejtimg" src="./images/shield.svg" alt=""/>
                                            <h6 className={'text-normal just-center pt-2'}> کارت بانکی باید به نام صاحب حساب کاربری باشد</h6>
                                         </div>
                           



                                                 <div className="google-input-container mgtb18">
                        <input
                            type="tel"
                            className={`google-input   ${cardNumber ? 'has-value' : '' }`}
                            value={cardNumber}
                            name="card_number"
                            maxLength={19}
                            onChange={handleChange}
                        />
                        <label className="google-placeholder">شماره کارت</label>

                        <div className={'text-danger error-message2024'}>
                                                   {errorBank}
                                               </div>
                        </div>



                        
                        <div className={'google-input-container mgtb18'}>
                                                     <div className={'row'}>
                                                             <div className={'col-10 pl-2 pr-0'}>
                                                             <input
                            type="tel"
                            className={`google-input sdjfsf-4jsdnjfwwweh224   ${shebaNumber ? 'has-value' : '' }`}
                            value={shebaNumber}
                            name="sheba"
                            maxLength={24}
                            onChange={handleChange}
                        />
                        <label className="google-placeholder">شماره شبا</label>


                                                             </div>
                                                             <div className={'col-2 tex-center pl-0 '}>
                                                                 <input type={'text'} className="form-control KSJDHSG545335 input-ehraz" value={'IR'} readOnly={true}/>
                                                             </div>

                                                         </div>
                                                          <div className={'error-message2024 text-danger  '}>
                                                           {errorSheba}
                                                          </div>

                                                     </div>

                                                  



                                     <div className={'text-center align-items-center pb-3'}>
                                    <button onClick={handelSubmit}  className={'btn-sehraz '}>


                                    {isLoading ? 
                                                    <i className="fa fa-spinner fa-spin"></i>
                                                    :

                                                 <span>ارسال</span>
                                                }

                                    </button>

                                </div>



            </div>


            </div>

        </MangeDashboard>
    )

}